import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
};

export default function SupportReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_SUPPORT_SUCCESS_ACTION:
      return {
        ...state,
        SupportLoader: false,
        SupportList: action.payload.response_data.results,
      };
    case actionTypes.FETCH_SUPPORT_INIT_ACTION:
      return {
        ...state,
        SupportLoader: true,
        SupportList: [],
      };
    case actionTypes.FETCH_SUPPORT_FAIL_ACTION:
      return {
        ...state,
        SupportLoader: false,
        SupportList: [],
      };

    case actionTypes.FETCH_SUPPORT_ISSUE_SUCCESS_ACTION:
      return {
        ...state,
        supportIssueList: action.payload.response_data,
      };
    case actionTypes.FETCH_SUPPORT_ISSUE_FAIL_ACTION:
      return {
        ...state,
        supportIssueList: {},
      };

    case actionTypes.FETCH_SUPPORT_CHAT_SUCCESS_ACTION:
      return {
        ...state,
        supportChatList: action.payload.response_data,
      };
    case actionTypes.FETCH_SUPPORT_CHAT_FAIL_ACTION:
      return {
        ...state,
        supportChatList: {},
      };

    case actionTypes.FETCH_SUPPORT_AGENT_SUCCESS_ACTION:
      return {
        ...state,
        agentNameList: action.payload.response_data,
      };
    case actionTypes.FETCH_SUPPORT_AGENT_FAIL_ACTION:
      return {
        ...state,
        agentNameList: {},
      };

    case actionTypes.FETCH_SUPPORT_CONTACTS_SUCCESS_ACTION:
      return {
        ...state,
        SupportContactsList: action.payload,
      };
    case actionTypes.FETCH_SUPPORT_CONTACTS_FAIL_ACTION:
      return {
        ...state,
        SupportContactsList: [],
      };

    case actionTypes.FETCH_PROFILE_SUCCESS_ACTION:
      return {
        ...state,
        SupportProfileList: action.payload.response_data,
      };
    case actionTypes.FETCH_PROFILE_FAIL_ACTION:
      return {
        ...state,
        SupportProfileList: {},
      };
    case actionTypes.FETCH_SUPPRTADDAPT_SUCCESS_ACTION:
      return {
        ...state,
        SupportAddAptList: action.payload.response_data.aptList,
      };

    default:
      return {
        ...state,
      };
  }
}
